interface Props {
  dateFrom: string;
  dateTo: string;
  onDateFromChange: (v: string) => void;
  onDateToChange: (v: string) => void;
}

const PRESETS: { label: string; days: number | null }[] = [
  { label: '90D', days: 90 },
  { label: '1Y', days: 365 },
  { label: '5Y', days: 1825 },
  { label: 'ALL', days: null },
];

function daysAgo(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d.toISOString().slice(0, 10);
}

export function DateRangeFilter({ dateFrom, dateTo, onDateFromChange, onDateToChange }: Props) {
  const applyPreset = (days: number | null) => {
    if (days === null) {
      onDateFromChange('');
      onDateToChange('');
    } else {
      onDateFromChange(daysAgo(days));
      onDateToChange('');
    }
  };

  return (
    <div className="flex items-center gap-2">
      {PRESETS.map((p) => (
        <button
          key={p.label}
          onClick={() => applyPreset(p.days)}
          className="px-2 py-1 text-xs tracking-wider text-mono-500 hover:text-mono-200 hover:bg-mono-800 rounded transition-colors"
        >
          {p.label}
        </button>
      ))}
      <input
        type="date"
        value={dateFrom}
        onChange={(e) => onDateFromChange(e.target.value)}
        className="bg-mono-900 border border-mono-700 text-mono-200 text-xs px-2 py-1 rounded focus:outline-none focus:border-mono-500"
      />
      <span className="text-mono-400 text-xs">to</span>
      <input
        type="date"
        value={dateTo}
        onChange={(e) => onDateToChange(e.target.value)}
        className="bg-mono-900 border border-mono-700 text-mono-200 text-xs px-2 py-1 rounded focus:outline-none focus:border-mono-500"
      />
    </div>
  );
}
